import { useImperativeHandle, ForwardedRef } from "react";

/**
 * Hook to expose any internal value or getter to a parent through a ref
 *
 * @param ref - The ref to expose values through
 * @param exposedValues - Object with values/getters to expose
 *
 * @example
 * const MyComponent = forwardRef((props, ref) => {
 *   const [hasChanges, setHasChanges] = useState(false);
 *   useExposedState(ref, {
 *     get hasChanges() { return hasChanges; }
 *   });
 *   return (...);
 * });
 */
export default function useExposedState<T>(
  ref: ForwardedRef<T>,
  exposedValues: T
): void {
  useImperativeHandle(ref, () => exposedValues, [exposedValues]);
}
